export default function scrollToBottom() {
  const elem = document.getElementById("visit_step_container");
  setTimeout(() => {
    elem.scrollTo({ top: elem.scrollHeight, behavior: "smooth" });
  }, 500);
}
